import React, { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";

function PurchaseHistory() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPurchaseHistory = async () => {
      const user = auth.currentUser;
      if (!user) return;

      console.log("Logged in user ID:", user.uid);

      try {
        const q = query(
          collection(db, "processedSessions"),
          where("userId", "==", user.uid),
          orderBy("createdAt", "desc")
        );
        const querySnapshot = await getDocs(q);
        const results = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        console.log("Purchase History Query Results:", results);
        setSessions(results);
      } catch (err) {
        console.error("Error fetching sessions:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPurchaseHistory();
  }, []);

  return (
    <DashboardLayout>
      <div className="p-8 text-white font-[Montserrat]">
        <div className="flex justify-center items-center gap-4 mb-6">
          <button
            className="px-4 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded flex items-center font-bold"
            onClick={() => navigate(-1)}
          >
            <span className="mr-2">←</span>Back
          </button>
          <h2 className="text-2xl font-bold font-[Montserrat]">Purchase History</h2>
        </div>

        {loading ? (
          <p className="text-center">Loading...</p>
        ) : sessions.length === 0 ? (
          <p className="text-center">No purchases found.</p>
        ) : (
          <div className="flex flex-col items-center space-y-4">
            {sessions.map((session) => (
              <div
                key={session.id}
                className="w-[30%] bg-gray-800 rounded-xl p-6 shadow border border-gray-600 text-left"
              >
                <p><strong>Credits Purchased:</strong> {session.creditsPurchased}</p>
                <p><strong>Amount Paid:</strong> ${(session.amountTotal / 100).toFixed(2)}</p>
                <p><strong>Product:</strong> {session.productName || "—"}</p>
                <p><strong>Purchase Date:</strong> {new Date(session.createdAt?.toDate?.() || session.createdAt).toLocaleString()}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}

export default PurchaseHistory;
